/**
 * extracts the current language from the routes URL
 *
 * @param url
 * @param languages
 * @param defaultLanguage
 * @returns currentLanguage {String}
 */
export const getCurrentLanguage = function (url, languages, defaultLanguage) {
  const path = getSafePath(url);

  const firstSegment = (path.split("/").filter(Boolean)[0] || "").toLowerCase();
  if (!firstSegment) {
    return defaultLanguage;
  }

  const exact = languages.find((l) => l.toLowerCase() === firstSegment);
  if (exact) {
    return exact;
  }

  for (let i = 0; i < languages.length; i++) {
    const language = languages[i];
    if (path.toLowerCase().indexOf("/" + language.toLowerCase()) > -1) return language;
  }
  return defaultLanguage;
};

export const getSafePath = function (url) {
  try {
    return new URL(url, "http://placeholder.local").pathname;
  } catch {
    return String(url);
  }
};

export const setURLSearchParams = function (url, param) {
  return url + (url.indexOf("?") > -1 ? "&" : "?") + param;
};

export const isComponentPreview = function () {
  const url = useRoute().fullPath;
  return url.includes("isComponentPreview=true");
};

/**
 * @deprecated
 * composables/useMagnoliaContext.ts:7
 *
 * @returns {boolean}
 */
export const isEditMode = function () {
  const fullPath = useRoute().fullPath;
  return fullPath.includes("mgnlPreview=false");
};

/**
 * @deprecated
 * composables/useMagnoliaContext.ts:7
 *
 * @returns {boolean}
 */
export const isMagnoliaPreview = function () {
  const fullPath = useRoute().fullPath;
  return fullPath.includes("mgnlPreview=true");
};

export const mgnlVersionedRequest = function () {
  const query = useRoute().query;
  if (query.mgnlVersion !== undefined) return query.mgnlVersion;
};

export const cleanFullPath = () => {
  let fullPath = useRoute().fullPath;
  // remove file endings
  fullPath = fullPath.replace(".html", "");
  // remove hashbang parameters
  fullPath = fullPath.split("#")?.[0];
  // remove get parameters
  fullPath = fullPath.split("?")?.[0];
  // remove potential double slashes
  fullPath = fullPath.replace("//", "/");
  // remove trailing slashes
  fullPath = fullPath.endsWith("/") ? fullPath.substring(0, fullPath.length - 1) : fullPath;
  return fullPath;
};
